import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    position: 'relative',
    width: '100%',
    minHeight: '100%',
  },
  flexDisplay: {
    display: 'flex',
  },
  grow: {
    flexGrow: 1,
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  titleBar: {
    marginTop: '10px',
    marginBottom: '10px',
    padding: '20px',
    display: 'flex',
  },
  stepContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    width: 800,
    [theme.breakpoints.down('xl')]: {
      width: 725,
    },
    [theme.breakpoints.down('lg')]: {
      width: 650,
    },
    [theme.breakpoints.down('md')]: {
      width: 550,
    },
    [theme.breakpoints.down('sm')]: {
      width: 425,
    },
    flexDirection: 'column',
    alignItems: 'center',
  },
  stepPaper: {
    width: '100%',
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  availabilityOption: {
    flexDirection: 'row',
    marginLeft: '30px',
  },
  dateRangeRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    gap: theme.spacing(1),
  },
  dateRangePicker: {
    width: 150,
    flexShrink: 0,
  },
  availabilityInput: {
    padding: '0px',
    fontSize: 'medium',
    width: '150px',
    margin: '10px',
    verticalAlign: 'middle',
  },
  inputText: {
    fontSize: 14,
    padding: '8px',
  },
  checkboxText: {
    fontSize: 8,
    padding: '2px',
  },
  noWrapContainer: {
    flexWrap: 'nowrap',
  },
  payloadSelectionBox: {
    marginTop: '10px',
  },
  quantitySelectionBox: {
    marginTop: '20px',
  },
  intervalInput: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: 'auto',
    marginBottom: 'auto',
    verticalAlign: 'middle',
    width: '50px',
  },
  monthFrequencySelect: {
    margin: theme.spacing(1),
    textTransform: 'capitalize',
    width: '75px',
    '& .MuiOutlinedInput-input': {
      padding: `${theme.spacing(1)} ${theme.spacing(4)} ${theme.spacing(1)} ${theme.spacing(1)}`,
      textTransform: 'capitalize',
      fontSize: '14px',
    },
  },
  optionDisabled: {
    fontStyle: 'italic',
    color: '#cccccc',
  },
  pForm_selectionBox: {
    maxHeight: 510,
    display: 'flex',
    flexWrap: 'wrap',
    width: 350,
    // [theme.breakpoints.down('lg')]: {
    //   width: 300,
    // },
    // [theme.breakpoints.down('md')]: {
    //   width: 300,
    // },
    // [theme.breakpoints.down('sm')]: {
    //   width: 300,
    // },
    // [theme.breakpoints.down('xs')]: {
    //   width: 300,
    // },
  },
  checkboxTreeContainer: {
    width: '100%',
    minHeight: 320,
    border: `solid #eee 1px`,
    borderRadius: '3px',
    padding: '10px',
  },
  treeContainer: {
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    alignItems: 'center',
  },
  searchContainer: {
    width: '70%',
    justifySelf: 'center',
    padding: theme.spacing(1, 1, 1, 1),
  },
  search: {
    position: 'relative',
    borderRadius: `${theme.shape.borderRadius}px`,
    borderColor: 'black',
    backgroundColor: 'white',
    width: '100%',
  },
  searchIcon: {
    pointerEvents: 'none',
  },
  stepContainer_section: {
    width: '100%',
    padding: '15px',
  },
  stepContainer_header: {
    alignItems: 'center',
    fontFamily: 'Roboto',
    display: 'flex',
    gap: '8px',
    padding: '5px',
    paddingLeft: '15px',
    backgroundColor: '#DCDCDC',
  },
  infoIcon: {
    cursor: 'pointer',
  },
  applyRules_section: {
    display: 'flex',
    wrap: 'no-wrap',
    padding: '15px',
    flexDirection: 'column',
  },
  previewSection: {
    fontSize: '14px',
  },
  applyRules_sectionText: {
    fontSize: '16px',
    marginLeft: '5%',
  },
  button: {
    margin: theme.spacing(1),
  },
  margin1: {
    margin: theme.spacing(1),
  },
  margin2: {
    margin: theme.spacing(2),
  },
  paddingRL: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  keyColorBox: {
    width: '12px',
    height: '12px',
    marginRight: '8px',
    borderRadius: '3px',
  },
  itemContainer: {
    padding: '8px',
    flexGrow: 1,
    minHeight: '100px',
  },
  provisionPanelContent: {
    p: 4,
    width: '100%',
  },
  provisionSelector: {
    width: '100%',
  },
});

export const getStepperStyles = (theme: Theme) => ({
  root: {
    width: '100%',
    borderRadius: `${theme.shape.borderRadius}px`,
    borderColor: 'black',
  },
});
